import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";

const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0"; const PURPLE = "#845EF7";

const COLORS = [TEAL, CORAL, YELLOW, PURPLE];
const ICONS = ["🏁", "🚀", "🎉", "🎯"];

const TimelineSection = ({ events }) => (
  <AnimatedSection sx={{ backgroundColor: "#FFF8F0", py: { xs: 9, md: 12 } }}>
    <Container maxWidth="xl">
      <SectionHeading
        eyebrow="Academic Calendar"
        title="The Year at St Lord's 📅"
        description="A year filled with learning, activities, celebrations and opportunities for students to take part and grow."
        align="center"
        eyebrowColor={TEAL}
        eyebrowBg="#E6FFF7"
      />

      {/* Timeline */}
      <Box sx={{ position: "relative", maxWidth: 800, mx: "auto" }}>
        {/* Center line */}
        <Box sx={{ position: "absolute", left: "50%", top: 0, bottom: 0, width: 4, backgroundColor: NAVY, transform: "translateX(-50%)", borderRadius: 2, display: { xs: "none", md: "block" } }} />

        {events.map((ev, i) => {
          const isLeft = i % 2 === 0;
          return (
            <Box
              key={i}
              sx={{
                display: "flex",
                justifyContent: { xs: "flex-start", md: isLeft ? "flex-end" : "flex-start" },
                mb: 4,
                pl: { xs: 0, md: isLeft ? 0 : "54%" },
                pr: { xs: 0, md: isLeft ? "54%" : 0 },
                position: "relative",
              }}
            >
              {/* Dot */}
              <Box sx={{ position: "absolute", left: { xs: -10, md: "calc(50% - 18px)" }, top: 20, width: 36, height: 36, borderRadius: "50%", backgroundColor: COLORS[i % COLORS.length], border: `3px solid ${NAVY}`, display: "grid", placeItems: "center", fontSize: "1rem", zIndex: 2, boxShadow: `3px 3px 0 ${NAVY}`, animation: `bounce ${2 + i * 0.4}s ease-in-out infinite` }}>
                {ICONS[i]}
              </Box>

              {/* Card */}
              <Box sx={{ ml: { xs: 5, md: 0 }, p: 3, borderRadius: "16px", border: `2.5px solid ${NAVY}`, backgroundColor: "#fff", boxShadow: `5px 5px 0 ${NAVY}`, width: { xs: "100%", md: "auto" }, transition: "all 0.2s", "&:hover": { transform: "translate(-2px,-2px)", boxShadow: `7px 7px 0 ${NAVY}` } }}>
                <Box sx={{ display: "inline-block", px: 2, py: 0.3, mb: 1, borderRadius: "6px", backgroundColor: COLORS[i % COLORS.length], border: `2px solid ${NAVY}`, fontFamily: "'Space Grotesk', sans-serif", fontWeight: 800, fontSize: "0.75rem", color: NAVY }}>
                  {ev.period}
                </Box>
                <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.15rem", color: NAVY, mb: 1 }}>{ev.title}</Typography>
                <Typography sx={{ color: "#4A4E6D", fontWeight: 600, lineHeight: 1.7, fontSize: "0.88rem" }}>{ev.description}</Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Container>
  </AnimatedSection>
);

export default TimelineSection;
